/* eslint-disable camelcase */
import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import {
    alerts,
    dynamicSelectors,
    getTopMenuClicked,
    storeActions,
    unchecked_count,
    cartItems,
} from '@src/ducks';
import {
    fetchAlerts,
    fetchUncheckedAlertsCount,
    fetchCartItems,
} from '@src/requests';
import { fetchBottomMenu, fetchMobileMenu, fetchTopMenu } from '@src/requests/fetchMenus';
import {
    isBottomMenuLoading,
    isMobileMenuLoading,
    isTopMenuLoading,
    getBottomMenu,
    getMobileMenu,
    getTopMenu,
} from '@src/selectors/menus';
import { unique } from '@src/utils/componentHelpers';

import { ImpersonateBar } from '@src/components/impersonateBar';

import HeaderMenuBottom from './HeaderMenuBottom';
import HeaderMenuTop from './HeaderMenuTop';
import MobileHeader from './MobileHeader';

import './header.scss';

const mapStateToProps = (state) => ({
    alerts: alerts.getAlerts(state),
    uncheckedCount: unchecked_count.getUnchecked_count(state),
    headerFavorites: dynamicSelectors.getDynamic(state, 'headerFavorites'),
    menuItemClicked: getTopMenuClicked(state),
    isBottomMenuLoading: isBottomMenuLoading(state),
    isMobileMenuLoading: isMobileMenuLoading(state),
    isTopMenuLoading: isTopMenuLoading(state),
    bottomMenu: getBottomMenu(state),
    mobileMenu: getMobileMenu(state),
    topMenu: getTopMenu(state),
    cartItems: cartItems.getCartItems(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({
        ...storeActions,
    }, dispatch),
});

class Header extends React.Component {
    static propTypes = {
        actions: PropTypes.objectOf(PropTypes.func),
        alerts: ImmutablePropTypes.map,
        isBottomMenuLoading: PropTypes.bool,
        isMobileMenuLoading: PropTypes.bool,
        isTopMenuLoading: PropTypes.bool,
        bottomMenu: PropTypes.arrayOf(PropTypes.object).isRequired,
        mobileMenu: PropTypes.arrayOf(PropTypes.object).isRequired,
        topMenu: PropTypes.arrayOf(PropTypes.object).isRequired,
        uncheckedCount: ImmutablePropTypes.map,
        cartItems: ImmutablePropTypes.map,
    };

    constructor(props) {
        super(props);

        // eslint-disable-next-line react/state-in-constructor
        this.state = {
            alerts: null,
            hoverMenuId: null,
            fetch: unique(),
            hoverActive: false,
            uncheckedCount: null,
            cartItems: null,
            width: 0,
            height: 0,
        };
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    };

    componentDidMount() {
        const { actions } = this.props;

        actions.appRequest(fetchBottomMenu(this.state.fetch));
        actions.appRequest(fetchMobileMenu(this.state.fetch));
        actions.appRequest(fetchTopMenu(this.state.fetch));
        actions.appRequest(fetchUncheckedAlertsCount(this.state.fetch));
        actions.appRequest(fetchCartItems(this.state.fetch));

        this.updateWindowDimensions();

        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentDidUpdate(prevProps) {
        const {
            alerts,
            uncheckedCount,
            cartItems,
        } = this.props;

        if (this.props !== prevProps) {
            this.setState({
                alerts: !alerts.toJS().loaded === 'complete' ? null : alerts.toJS(),
                uncheckedCount: uncheckedCount.toJS().loaded === 'loading' ? null : uncheckedCount.toJS(),
                cartItems: cartItems.toJS().loaded === 'loading' ? null : cartItems.toJS(),
            });
        }
    }

    handleAlertOnFocus = () => {
        const { actions } = this.props;

        actions.appRequest(fetchAlerts(this.fetch, '?perPage=5'));
    };

    handleOnMouseOverTop = () => {
        this.setState({
            hoverActive: false,
            hoverMenuId: null,
        });
    };

    handleOnMouseOver = (event) => {
        let newHoverMenuId = null;
        if (event.nativeEvent.target.attributes.menuindex) {
            newHoverMenuId = event.nativeEvent.target.attributes.menuindex.value;
        }

        if (newHoverMenuId) {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    hoverActive: true,
                    hoverMenuId: newHoverMenuId,
                };
            });
        }
    };

    handleOnMouseLeave = () => {
        this.setState({
            hoverActive: false,
            hoverMenuId: null,
        });
    };

    handleOnFocus = (event) => {
        let newHoverMenuId = null;
        if (event.nativeEvent.target.attributes.menuindex) {
            newHoverMenuId = event.nativeEvent.target.attributes.menuindex.value;
        }

        if (newHoverMenuId) {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    hoverActive: true,
                    hoverMenuId: newHoverMenuId,
                };
            });
        }
    };

    handleOnBlur = (event) => {
        const latestLink = 'https://www.socialmediasuitcase.com/grab-and-go-posts';
        let isLatest = false;

        if (event.nativeEvent.target.attributes.href) {
            isLatest = event.nativeEvent.target.attributes.href.value === latestLink;
        }

        if (isLatest) {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    hoverActive: false,
                    hoverMenuId: null,
                };
            });
        }
    };

    handleBottomMenuOnClick = () => {
        this.setState({
            hoverActive: false,
            hoverMenuId: null,
        });
    };

    render() {
        if (this.props.isBottomMenuLoading || this.props.isTopMenuLoading) {
            return null;
        }

        return (
            <header className="row fixed-top no-gutters">
                <ImpersonateBar />
                <Col>
                    {
                        this.state.width > 991
                        && (
                            <>
                                <HeaderMenuTop
                                    key="header-menu-top"
                                    {...this.state}
                                    topMenu={this.props.topMenu}
                                    onMouseOver={this.handleOnMouseOverTop}
                                    onAlertFocus={this.handleAlertOnFocus}
                                />
                                <HeaderMenuBottom
                                    key="header-menu-bottom"
                                    {...this.state}
                                    menus={this.props.bottomMenu}
                                    onMouseOver={this.handleOnMouseOver}
                                    onMouseLeave={this.handleOnMouseLeave}
                                    onFocus={this.handleOnFocus}
                                    onBlur={this.handleOnBlur}
                                    onClick={this.handleBottomMenuOnClick}
                                />
                            </>
                        )
                    }
                    {
                        this.state.width < 992
                        && <MobileHeader
                            key="header-menu-mobile"
                            {...this.state}
                            menus={this.props.mobileMenu}
                        />
                    }
                </Col>
            </header>
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
